"use strict";

/**
 * JS-son world field type generator
 * @param {string} id Unique identifier of field type
 * @param {function} generateClass Determines field's table cell class based on state, position
 * @param {function} generateCharRep Determines field's cli representation, based on state, position
 * @param {function} generateConsequence Determines effect of action in field to agent and env
 * @param {function} generateAnnotation Determines field's annotation, based on state, position
 * @returns {object} JS-son grid world field type
*/
var FieldType = function FieldType(id, generateClass, generateCharRep, generateConsequence) {
  var generateAnnotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return '';
  };
  return {
    id: id,
    render: function render(state, position) {
      var browser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return browser ? "<td class=\"".concat(generateClass(state, position), "\">").concat(generateAnnotation(state, position), "</td>") : generateCharRep(state, position);
    },
    trigger: function trigger(actions, agentId, state, position) {
      return generateConsequence(actions, agentId, state, position);
    }
  };
};

module.exports = FieldType;